import React from 'react';
import { Layout, LayoutProps } from 'react-admin';
import CustomMenu from './Menu';
import { TwoFAModal } from './TwoFAModal';

const CustomLayout = (props: LayoutProps) => (
	<>
		<Layout {...props} menu={CustomMenu} />
		<TwoFAModal />
	</>
);

export default CustomLayout;
